'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var charList = require('../character-list/character-list.json');
var faIconChars = charList.icons;

exports.default = faIconChars;
module.exports = exports['default'];